import { render, staticRenderFns } from "./RepresentacaoConjuntoList.vue?vue&type=template&id=6fb66e29"
import script from "./RepresentacaoConjuntoList.vue?vue&type=script&lang=js"
export * from "./RepresentacaoConjuntoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports